import React, { useEffect, useState } from "react";
import {
    getgrievancedata,
    addrrupdategrievancedata,
} from "../../../Services/UserService/clientService";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import Loader from "../../../../Utils/Loader";

const Grievancedata = () => {

     
    const token = localStorage.getItem("token");
    const user_id = localStorage.getItem("id");

    const [complainData, setComplainData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const getsettingdetail = async () => {
        try {
            setIsLoading(true)
            const response = await getgrievancedata(token);
            if (response.status) {
                setComplainData(response.data || {});
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getsettingdetail();
    }, []);

    if (isLoading) {
        return (
            <div>
                <Loader />
            </div>
        );
    }

    // ✅ Fixed branch names
    const branchNames = ["Grievance officer", "Customer Care", "Head of Customer Care", "Compliance Officer", "CEO", "Principal Officer"];

    // ✅ Validation Schema
    const validationSchema = Yup.object().shape(
        branchNames.reduce((schema, _, i) => {
            const idx = i + 1;
            schema[`address${idx}`] = Yup.string().required("Address is required");
            schema[`contact_person_name${idx}`] = Yup.string().required("Contact Person is required");
            schema[`contact${idx}`] = Yup.string()
                .required("Contact is required")
            schema[`email${idx}`] = Yup.string()
                .email("Invalid email format")
                .required("Email is required");
            schema[`workinghours${idx}`] = Yup.string().required("Working Hours is required");
            return schema;
        }, {})
    );

    return (
        <div className="page-content">
            <div className="page-breadcrumb d-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Grievance</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">
                                <Link to="/admin/dashboard">
                                    <i className="bx bx-home-alt" />
                                </Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-12 mx-auto">
                    <div className="card radius-15">
                        <Formik
                            enableReinitialize={true}
                            initialValues={branchNames.reduce((vals, _, i) => {
                                const idx = i + 1;
                                vals[`address${idx}`] = complainData[`address${idx}`] || "";
                                vals[`contact_person_name${idx}`] = complainData[`contact_person_name${idx}`] || "";
                                vals[`contact${idx}`] = complainData[`contact${idx}`] || "";
                                vals[`email${idx}`] = complainData[`email${idx}`] || "";
                                vals[`workinghours${idx}`] = complainData[`workinghours${idx}`] || "";
                                return vals;
                            }, {})}
                            validationSchema={validationSchema}
                            onSubmit={async (values, { setSubmitting }) => {
                                const req = {
                                    ...values,
                                    id: user_id,
                                };

                                try {
                                    const response = await addrrupdategrievancedata(req, token);
                                    if (response.status) {
                                        showCustomAlert("Success", response.message);
                                        getsettingdetail();
                                    } else {
                                        showCustomAlert("error", response.message);
                                    }
                                } catch (error) {
                                    showCustomAlert(
                                        "error",
                                        "An unexpected error occurred. Please try again later."
                                    );
                                } finally {
                                    setSubmitting(false);
                                }
                            }}
                        >
                            {({ dirty, isSubmitting }) => (
                                <Form className="card-body">

                                    {branchNames.map((branchName, i) => {
                                        const idx = i + 1;
                                        return (
                                            <div key={idx} className="border rounded p-3 mb-3">
                                                <h6 className="mb-3">{branchName}</h6>

                                                <div className="row mb-2">
                                                    <label className="col-sm-3 col-form-label">Address</label>
                                                    <div className="col-sm-9">
                                                        <Field
                                                            name={`address${idx}`}
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage
                                                            name={`address${idx}`}
                                                            component="div"
                                                            className="error"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-2">
                                                    <label className="col-sm-3 col-form-label">Contact</label>
                                                    <div className="col-sm-9">
                                                        <Field
                                                            name={`contact${idx}`}
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage
                                                            name={`contact${idx}`}
                                                            component="div"
                                                            className="error"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-2">
                                                    <label className="col-sm-3 col-form-label">Contact Person</label>
                                                    <div className="col-sm-9">
                                                        <Field
                                                            name={`contact_person_name${idx}`}
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage
                                                            name={`contact_person_name${idx}`}
                                                            component="div"
                                                            className="error"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-2">
                                                    <label className="col-sm-3 col-form-label">Email</label>
                                                    <div className="col-sm-9">
                                                        <Field
                                                            name={`email${idx}`}
                                                            type="email"
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage
                                                            name={`email${idx}`}
                                                            component="div"
                                                            className="error"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-2">
                                                    <label className="col-sm-3 col-form-label">Working Hours</label>
                                                    <div className="col-sm-9">
                                                        <Field
                                                            name={`workinghours${idx}`}
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage
                                                            name={`workinghours${idx}`}
                                                            component="div"
                                                            className="error"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}

                                    <div className="row mt-3">
                                        <label className="col-sm-3 col-form-label" />
                                        <div className="col-sm-9">
                                            <div className="d-flex justify-content-end">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary px-4"
                                                    disabled={!dirty || isSubmitting}
                                                >
                                                    {isSubmitting ? "Updating..." : "Update"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        <style jsx>{`
                            .error {
                                color: red;
                                font-size: 14px;
                            }
                        `}</style>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Grievancedata;
